import clsx from 'clsx'
import React, { FC } from 'react'

import { SmallShippingUrgencyTimer } from '@Components/UrgencyTimer/SmallUrgencyTimer/smallShippingUrgencyTimer'

import styles from './UrgencyTimer.module.scss'

interface ShippingModalUrgencyTimerPorps{
  className?: string
}
export const ShippingModalUrgencyTimer: FC<ShippingModalUrgencyTimerPorps> = ({ className }) => (
  <div className={clsx(styles.shippingModalUrgencyTimer, className)}>
    <SmallShippingUrgencyTimer
      className={styles.urgencyTimer}
    />
  </div>
)
